var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, put, takeLatest } from "redux-saga/effects";
import logger from "../../logger";
import * as contractActions from "../../reduxV2/contract/contract.actions";
import * as contractApiV2 from "../../reduxV2/contract/contract.api";
import * as propertyActionsV2 from "../../reduxV2/property/property.actions";
import * as propertyApiV2 from "../../reduxV2/property/property.api";
import { showAlert } from "../../utils/alert/alert.utils";
import { getGeneralUpdateSuccessText, getLocalizedText, } from "../../utils/i18n/i18n.utils";
import { generateSaga } from "../generators/generator.saga";
import { getInsuranceStart, getInsuranceSucceeded, getInsuranceFailed, resendInsuranceInviteExternalStart, resendInsuranceInviteExternalSucceeded, resendInsuranceInviteExternalFailed, pollInsuranceStatusExternalStart, pollInsuranceStatusExternalSucceeded, pollInsuranceStatusExternalFailed, resetInsuranceProposalStart, resetInsuranceProposalSucceeded, resetInsuranceProposalFailed, getInsuranceForContractStart, getInsuranceForContractSucceeded, getInsuranceForContractFailed, publishInsuranceStart, publishInsuranceSucceeded, publishInsuranceFailed, } from "./insurance.actions";
import * as insuranceApi from "./insurance.api";
import { GENERATOR_PARAMS } from "./insurance.constants";
function getInsuranceStartFlow(action) {
    var payload, id, onSuccess, onFailure, insurance, unknownError_1, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                id = payload.id, onSuccess = payload.onSuccess, onFailure = payload.onFailure;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(insuranceApi.getInsurance, id)];
            case 2:
                insurance = _a.sent();
                return [4 /*yield*/, put(getInsuranceSucceeded.getAction({
                        data: insurance,
                    }))];
            case 3:
                _a.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(insurance);
                return [3 /*break*/, 6];
            case 4:
                unknownError_1 = _a.sent();
                error = unknownError_1;
                logger.logError({ error: error });
                return [4 /*yield*/, put(getInsuranceFailed.getAction({
                        id: id,
                        error: error,
                    }))];
            case 5:
                _a.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function resendInsuranceInviteExternalStartFlow(action) {
    var payload, id, onSuccess, onFailure, insurance, unknownError_2, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                id = payload.id, onSuccess = payload.onSuccess, onFailure = payload.onFailure;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(insuranceApi.resendInsuranceInviteExternal, id)];
            case 2:
                insurance = _a.sent();
                return [4 /*yield*/, put(resendInsuranceInviteExternalSucceeded.getAction({
                        data: insurance,
                    }))];
            case 3:
                _a.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(insurance);
                showAlert({
                    type: "success",
                    message: getLocalizedText("insurance.resend_invite.alert.success"),
                });
                return [3 /*break*/, 6];
            case 4:
                unknownError_2 = _a.sent();
                error = unknownError_2;
                logger.logError({ error: error });
                return [4 /*yield*/, put(resendInsuranceInviteExternalFailed.getAction({
                        id: id,
                        error: error,
                    }))];
            case 5:
                _a.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function pollInsuranceStatusExternalStartFlow(action) {
    var payload, id, onSuccess, onFailure, insurance, unknownError_3, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                id = payload.id, onSuccess = payload.onSuccess, onFailure = payload.onFailure;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(insuranceApi.pollInsuranceStatusExternal, id)];
            case 2:
                insurance = _a.sent();
                return [4 /*yield*/, put(pollInsuranceStatusExternalSucceeded.getAction({
                        data: insurance,
                    }))];
            case 3:
                _a.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(insurance);
                showAlert({
                    type: "success",
                    message: getLocalizedText("insurance.insurance.poll.alert.success"),
                });
                return [3 /*break*/, 6];
            case 4:
                unknownError_3 = _a.sent();
                error = unknownError_3;
                logger.logError({ error: error });
                return [4 /*yield*/, put(pollInsuranceStatusExternalFailed.getAction({
                        id: id,
                        error: error,
                    }))];
            case 5:
                _a.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function resetInsuranceProposalStartFlow(action) {
    var payload, externalCode, contractId, onSuccess, onFailure, insurance, unknownError_4, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                externalCode = payload.externalCode, contractId = payload.contractId, onSuccess = payload.onSuccess, onFailure = payload.onFailure;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 6, , 8]);
                return [4 /*yield*/, call(insuranceApi.resetInsuranceProposal, externalCode)];
            case 2:
                insurance = _a.sent();
                if (!insurance) return [3 /*break*/, 5];
                return [4 /*yield*/, put(resetInsuranceProposalSucceeded.getAction({
                        contractId: contractId,
                    }))];
            case 3:
                _a.sent();
                return [4 /*yield*/, put(contractActions.getDetailStart.getAction({ id: contractId }))];
            case 4:
                _a.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(contractId);
                showAlert({
                    type: "success",
                    message: getGeneralUpdateSuccessText("insurance"),
                });
                _a.label = 5;
            case 5: return [3 /*break*/, 8];
            case 6:
                unknownError_4 = _a.sent();
                error = unknownError_4;
                logger.logError({ error: error });
                return [4 /*yield*/, put(resetInsuranceProposalFailed.getAction({
                        error: error,
                    }))];
            case 7:
                _a.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function getInsuranceForContractStartFlow(action) {
    var payload, contractId, onSuccess, onFailure, insurance, unknownError_5, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                contractId = payload.contractId, onSuccess = payload.onSuccess, onFailure = payload.onFailure;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(insuranceApi.getInsuranceForContract, contractId)];
            case 2:
                insurance = _a.sent();
                return [4 /*yield*/, put(getInsuranceForContractSucceeded.getAction({
                        contractId: contractId,
                        data: insurance,
                    }))];
            case 3:
                _a.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(insurance);
                return [3 /*break*/, 6];
            case 4:
                unknownError_5 = _a.sent();
                error = unknownError_5;
                logger.logError({ error: error });
                return [4 /*yield*/, put(getInsuranceForContractFailed.getAction({
                        contractId: contractId,
                        error: error,
                    }))];
            case 5:
                _a.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function publishInsuranceStartFlow(action) {
    var payload, contractId, insuranceExternalAccessCode, propertyId, updatedProperty, onSuccess, onFailure, property, contract, unknownError_6, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                contractId = payload.contractId, insuranceExternalAccessCode = payload.insuranceExternalAccessCode, propertyId = payload.propertyId, updatedProperty = payload.updatedProperty, onSuccess = payload.onSuccess, onFailure = payload.onFailure;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 7, , 9]);
                return [4 /*yield*/, call(propertyApiV2.update, {
                        id: propertyId,
                        data: updatedProperty,
                    })];
            case 2:
                property = (_a.sent()).data;
                return [4 /*yield*/, put(propertyActionsV2.updateSucceeded.getAction({
                        id: propertyId,
                        result: property,
                    }))];
            case 3:
                _a.sent();
                // Request insurance
                return [4 /*yield*/, call(insuranceApi.publishInsurance, insuranceExternalAccessCode)];
            case 4:
                // Request insurance
                _a.sent();
                return [4 /*yield*/, call(contractApiV2.getDetail, {
                        id: contractId,
                    })];
            case 5:
                contract = (_a.sent()).data;
                return [4 /*yield*/, put(publishInsuranceSucceeded.getAction({
                        contractId: contractId,
                        contract: contract.data,
                    }))];
            case 6:
                _a.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                return [3 /*break*/, 9];
            case 7:
                unknownError_6 = _a.sent();
                error = unknownError_6;
                showAlert({ type: "error", error: error });
                logger.logError({ error: error });
                return [4 /*yield*/, put(publishInsuranceFailed.getAction({
                        error: error,
                        contractId: contractId,
                    }))];
            case 8:
                _a.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
export function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(getInsuranceStart.type, getInsuranceStartFlow)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(resendInsuranceInviteExternalStart.type, resendInsuranceInviteExternalStartFlow)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest(pollInsuranceStatusExternalStart.type, pollInsuranceStatusExternalStartFlow)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeLatest(resetInsuranceProposalStart.type, resetInsuranceProposalStartFlow)];
            case 4:
                _a.sent();
                return [4 /*yield*/, takeLatest(getInsuranceForContractStart.type, getInsuranceForContractStartFlow)];
            case 5:
                _a.sent();
                return [4 /*yield*/, takeLatest(publishInsuranceStart.type, publishInsuranceStartFlow)];
            case 6:
                _a.sent();
                return [4 /*yield*/, generateSaga(GENERATOR_PARAMS)];
            case 7:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
